import { endOfMonth, startOfMonth } from '@sequencehq/utils/dates'

export const getCurrentMonthDateRange = (
  now: Date = new Date()
): { startDate: Date; endDate: Date } => {
  return {
    startDate: startOfMonth(now),
    endDate: endOfMonth(now)
  }
}
